import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TrackerService } from '../../../services/tracker.service';
import { TrackeritemQueueService } from '../../../services/trackeritem.queue.service';
import { GfTranslateService } from '../../../../../core/services/core.translate.service';
import { StateService } from '@uirouter/angular';
import { TrackeritemMoveModalComponent } from '../../../lib/trackeritemMoveModal/trackeritem.move.component';
import { TrackeritemCloneModalComponent } from '../../../lib/trackeritemCloneModal/trackeritem.clone.component';
import { TrackeritemDeleteModalComponent } from '../deleteButton/trackeritem.delete.modal.component';
import * as _ from 'lodash';

@Component({
  selector: 'trackeritem-edit-toolbar',
  template: require('./trackeritem.toolbar.component.html'),
})
export class TrackeritemEditToolbarComponent implements OnInit {
  members: any[];
  assigneesSelectorOptions: any;
  @Input() trackeritem: any;
  @Input() tracker: any;
  @Input() project: any;
  @Input() assignees: any;
  @Input() acls: any;
  @Input() showAssignees: boolean = true; // This optional boolean flag allows for disabling the assignees dropdown from the toolbar

  @Output() onSave: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSaveAssignees: EventEmitter<any> = new EventEmitter<any>();

  currentUser: any;
  saveTarget: string;

  constructor(
    private trackerService: TrackerService, 
    private trackeritemQueueService: TrackeritemQueueService,
    private translateService: GfTranslateService,
    private stateService: StateService, 
    private modalService: NgbModal
) {
}

  ngOnInit() {
    this.currentUser = ''; // Set your current user
  }

  inQueue() {
    if (!_.isEmpty(this.trackeritem)) {
      return this.trackeritemQueueService.inQueue(this.trackeritem);
    }
    return false;
  }

  saveTrackeritem(stopRedirection: boolean, assigneesOnly: boolean, source: string) {
    let params = {stopRedirection: stopRedirection, assigneesOnly: assigneesOnly, source: source};
    this.onSave.emit(params);
  }

  saveLockStatus(lockStatus: any) {
    this.trackeritem.lockStatus = lockStatus;
    this.onSave.emit({stopRedirection: true, assigneesOnly: false, source: 'stay'});
  }

  deleteCallback() {
    this.trackerService.goToTracker(this.tracker);
  }

  saveAssignees(assignees: any) {
    this.assignees = assignees;
    this.onSaveAssignees.emit();
  }

  saveButtonTitle() {
    return this.inQueue() ? this.translateService.translate('Save and go to your next Queue item') : this.translateService.translate('Save and leave this page');
  }

  saveButtonText() {
    return this.inQueue() ? this.translateService.translate("What's Next?") : this.translateService.translate('Save Changes');
  }

  doCancel(e?: any) {
    if (!_.isEmpty(e)) {
      e.preventDefault();
    }
    this.trackerService.goToTracker(this.tracker);
  }

  openAdmin() {
    this.stateService.go('home.project.summary.trackeradmin', { tracker: this.tracker.id });
  }

  showMoveTrackeritem() {
    const modalRef = this.modalService.open(TrackeritemMoveModalComponent);
    modalRef.componentInstance.trackeritem = this.trackeritem;
    modalRef.componentInstance.tracker = this.tracker;
    modalRef.componentInstance.project = this.project;
    modalRef.componentInstance.close.subscribe(($event) => {
      modalRef.close();
    });
  }

  showCloneTrackeritem() {
    const modalRef = this.modalService.open(TrackeritemCloneModalComponent);
    modalRef.componentInstance.trackeritem = this.trackeritem;
    modalRef.componentInstance.tracker = this.tracker;
    modalRef.componentInstance.project = this.project;
    modalRef.componentInstance.close.subscribe(($event) => {
      modalRef.close();
    });
  }

  showDeleteTrackeritem() {
    const modalRef = this.modalService.open(TrackeritemDeleteModalComponent);
    modalRef.componentInstance.trackeritem = this.trackeritem;
    modalRef.componentInstance.onClose = () => {
      modalRef.close();
    };
    modalRef.componentInstance.onDelete = () => {
      modalRef.close();
      this.deleteCallback();
    };
  }
}
